import i18n from 'i18next';
import PATHS from '../Routers/PATHS';
import { Consts } from '../res';
import PieChartIcon from '@rsuite/icons/PieChart';
import DashboardIcon from '@rsuite/icons/legacy/Dashboard';
import ProjectIcon from '@rsuite/icons/Project';
import PeoplesIcon from '@rsuite/icons/Peoples';
import CouponIcon from '@rsuite/icons/Coupon';
import GearIcon from '@rsuite/icons/Gear';
import TextImageIcon from '@rsuite/icons/TextImage';
import PeopleSpeakerIcon from '@rsuite/icons/PeopleSpeaker';
import HelpOutlineIcon from '@rsuite/icons/HelpOutline';
import SpeakerIcon from '@rsuite/icons/Speaker';
import ReviewIcon from '@rsuite/icons/Review';
import ThreeColumnsIcon from '@rsuite/icons/ThreeColumns';


export const getSideBarData = () => {
    return [
        {
            name: i18n.t('General'), icon: <DashboardIcon />, link: null, subs: [
                { name: i18n.t('Dashboard'), icon: 'dashboard', link: PATHS.ADMIN_DASHBOARD.URL },
                { name: i18n.t('Announcements'), icon: 'newspaper', link: PATHS.ADMIN_NEWS.URL },
                { name: i18n.t('Instructors'), icon: 'id badge', link: PATHS.ADMIN_INSTRUCTORS.URL },
                { name: i18n.t('LearningTeam'), icon: 'chess', link: PATHS.ADMIN_TEAM_MEMBERS.URL },
                { name: i18n.t('SuccessStories'), icon: 'child', link: PATHS.ADMIN_SUCCESS_STORIES.URL },
                { name: i18n.t('HonorRoll'), icon: 'trophy', link: PATHS.ADMIN_HONOR_ROLL.URL },
                { name: i18n.t('FAQs'), icon: 'question circle', link: PATHS.ADMIN_FAQS.URL },
                { name: i18n.t('Calendar'), icon: 'calendar alternate', link: PATHS.ADMIN_COURSES_CALENDAR.URL },
                { name: i18n.t('Messages'), icon: 'envelope', link: PATHS.ADMIN_MESSAGES.URL },
                { name: i18n.t('Banners'), icon: 'images', link: PATHS.ADMIN_BANNERS.URL },
                { name: i18n.t('Accredits'), icon: 'registered', link: PATHS.ADMIN_ACCREDITS.URL },

            ]
        },
        {
            name: i18n.t('Blogging'), icon: <SpeakerIcon />, link: null, subs: [
                { name: i18n.t('Blogs'), icon: 'copy', link: PATHS.ADMIN_BLOGS.URL },
                { name: i18n.t('Categories'), icon: 'th', link: PATHS.ADMIN_BLOGS_CATEGORIES.URL },
                { name: i18n.t('Tags'), icon: 'tags', link: PATHS.ADMIN_BLOGS_TAGS.URL },
            ]
        },
        {
            name: i18n.t('HR'), icon: <PeoplesIcon />, link: null, subs: [
                { name: i18n.t('Permissions'), icon: 'lock', link: PATHS.ADMIN_ROLES.URL },
                { name: i18n.t('Admins'), icon: 'user secret', link: PATHS.ADMIN_ADMINS.URL },
                { name: i18n.t('Users'), icon: 'users', link: PATHS.ADMIN_USERS.URL },
            ]
        },
        {
            name: i18n.t('Finance'), color: 'red', icon: <CouponIcon />, link: null, subs: [
                { name: i18n.t('Packages'), color: 'red', icon: 'boxes', link: PATHS.ADMIN_PACKAGES.URL },
                { name: i18n.t('PackageProperties'), icon: 'list', link: PATHS.ADMIN_PACKAGE_PROPERTIES.URL },
                { name: i18n.t('Promotions'), icon: 'percent', link: PATHS.ADMIN_PROMOTIONS.URL },
                { name: i18n.t('Subscriptions'), icon: 'dollar', link: PATHS.ADMIN_SUBSCRIPTIONS.URL },
                { name: i18n.t('PackagesPolicies'), color: 'red', icon: 'balance scale', link: PATHS.ADMIN_PACKAGES_POLICIES.URL },
                { name: i18n.t('PackagesCategories'), color: 'red', icon: 'th', link: PATHS.ADMIN_PACKAGES_CATEGORIES.URL },
                { name: i18n.t('PackagesPacks'), color: 'red', icon: 'box', link: PATHS.ADMIN_PACKAGES_PACKS.URL },

            ]
        },
        {
            name: i18n.t('Programs'), color: 'red', icon: <ProjectIcon />, link: null, subs: [
                { name: i18n.t('InteractiveBookAdmin'), icon: 'book', link: PATHS.ADMIN_INTERACTIVE_BOOKS.URL },

                { name: i18n.t('OneDayCourses'), color: 'brown', icon: 'video play', link: PATHS.ADMIN_ONE_DAY_COURSES.URL },
                { name: i18n.t('Certifications'), color: 'red', icon: 'certificate', link: PATHS.ADMIN_CERTIFICATIONS.URL },
                { name: i18n.t('Courses'), color: 'red', icon: 'graduation', link: PATHS.ADMIN_COURSES.URL },
                { name: i18n.t('Units'), color: 'red', icon: 'file alternate outline', link: PATHS.ADMIN_UNITS.URL },
                { name: i18n.t('Topics'), color: 'red', icon: 'sort alphabet down', link: PATHS.ADMIN_TOPICS.URL },
                { name: i18n.t('UploadVideos'), icon: 'upload', link: PATHS.ADMIN_UPLOADS_VIDEOS.URL },
                { name: i18n.t('UploadBooks'), icon: 'upload', link: PATHS.ADMIN_UPLOADS_BOOKS.URL },
                { name: i18n.t('CourseResources'), icon: 'folder open', link: PATHS.ADMIN_COURSE_RESOURCES.URL },
            ]
        },
        {
            name: i18n.t('Questions'), icon: <HelpOutlineIcon />, link: null, subs: [
                { name: i18n.t('MCQS'), icon: 'list ol', link: PATHS.ADMIN_QUESTIONS_MCQS.URL },
                { name: i18n.t('Essay'), icon: 'edit outline', link: PATHS.ADMIN_QUESTIONS_ESSAY.URL },
                // { name: i18n.t('Text'), icon: 'comment outline', link: '/admin/questions/text' },
                { name: i18n.t('Composite'), icon: 'sort amount down', link: PATHS.ADMIN_QUESTIONS_COMPOSITE.URL },
                { name: i18n.t('FileQuestions'), icon: 'file code outline', link: PATHS.ADMIN_QUESTIONS_FILE.URL },
                { name: i18n.t('Sizes'), icon: 'object ungroup outline', link: PATHS.ADMIN_QUESTIONS_SIZES.URL },
            ]
        },
        {
            name: i18n.t('BadgesAndAttendance'), color: 'red', icon: <ReviewIcon />, link: null, subs: [

                { name: i18n.t('Badges'), color: 'red', icon: 'shield', link: PATHS.ADMIN_BADGES.URL },
                { name: i18n.t('CertsAttendance'), color: 'brown', icon: 'certificate', link: PATHS.ADMIN_CERT_ATTENDANCE.URL },
                { name: i18n.t('UserBadges'), color: 'red', icon: 'id badge', link: PATHS.ADMIN_USER_BADGES.URL },
                { name: i18n.t('UserCertsAttendance'), color: 'red', icon: 'address book', link: PATHS.ADMIN_CERT_USER_ATTENDANCE.URL },
            ]
        },
        {
            name: i18n.t('Companies'), icon: <ThreeColumnsIcon />, link: null, subs: [
                { name: i18n.t('Courses'), icon: 'graduation', link: PATHS.ADMIN_COMPANIES_COURSES.URL },
                { name: i18n.t('BusinessRequests'), icon: 'level down', link: PATHS.ADMIN_COMPANIES_REQUESTS.URL },
                { name: i18n.t('Companies'), icon: 'building', link: PATHS.ADMIN_COMPANIES.URL },
                { name: i18n.t('Proposals'), icon: 'handshake', link: PATHS.ADMIN_COMPANIES_PROPOSALS.URL },
            ]
        },
        {
            name: i18n.t('Reports'), icon: <PieChartIcon />, link: null, subs: [
                { name: i18n.t('Payments'), icon: 'payment', link: PATHS.ADMIN_REPORTS_PAYMENTS.URL },
                { name: i18n.t('ManualPayments'), icon: 'payment', link: PATHS.ADMIN_MANUAL_PAYMENTS.URL },
                { name: i18n.t('UserPerformance'), icon: 'chart pie', link: PATHS.ADMIN_USER_PERFORMANCE.URL },
                { name: i18n.t('UsersPerformances'), icon: 'area chart', link: PATHS.ADMIN_USERS_PERFORMANCES.URL },

            ]
        },
        {
            name: i18n.t('ContentReports'), icon: <PeopleSpeakerIcon />, link: null, subs: [
                { name: i18n.t('General'), icon: 'comment alternate outline', link: `${PATHS.ADMIN_REPORTS_CONTENTS.URL.substring(0, PATHS.ADMIN_REPORTS_CONTENTS.URL.lastIndexOf('/'))}/${Consts.REPORTS_TYPES.COURSE}` },
                { name: i18n.t('Questions'), icon: 'question', link: `${PATHS.ADMIN_REPORTS_CONTENTS.URL.substring(0, PATHS.ADMIN_REPORTS_CONTENTS.URL.lastIndexOf('/'))}/${Consts.REPORTS_TYPES.QUESTION}` },
                { name: i18n.t('Videos'), icon: 'video', link: `${PATHS.ADMIN_REPORTS_CONTENTS.URL.substring(0, PATHS.ADMIN_REPORTS_CONTENTS.URL.lastIndexOf('/'))}/${Consts.REPORTS_TYPES.VIDEO}` },
            ]
        },
        {
            name: i18n.t('Exams'), icon: <TextImageIcon />, link: null, subs: [
                { name: i18n.t('ExamsManagement'), icon: 'file alternate outline', link: PATHS.ADMIN_EXAMS.URL },
                { name: i18n.t('MockExams'), icon: 'file alternate outline', link: PATHS.ADMIN_MOCK_EXAMS.URL },
                { name: i18n.t('ExamCorrection'), icon: 'gavel', link: PATHS.ADMIN_EXAM_CORRECTION.URL },
            ]
        },
        {
            name: i18n.t('Settings'), icon: <GearIcon />, link: null, subs: [
                { name: i18n.t('SignInLogs'), icon: 'exclamation', link: PATHS.ADMIN_SETTINGS_IPLOGS.URL },
                { name: i18n.t('Notifications'), icon: 'bell', link: PATHS.ADMIN_SETTINGS_NOTIFICATIONS.URL },
                { name: i18n.t('Policies'), icon: 'privacy', link: PATHS.ADMIN_POLICY_TERMS.URL },
            ]
        },
    ];
};
